import { Component, Inject } from '@angular/core';
import { RouteController } from '@shared/src/controllers/route/route.controller';
import { AddressController } from '@shared/src/controllers/address/address.controller';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { SecurityController } from '@shared/src/controllers/security/security.controller';
import { ShipmentController } from '@shared/src/controllers/route/shipment/shipment.controller';
import { AlertService } from '@shared/src/public-api';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { PartnerDriverMaintenanceController } from '@shared/src/controllers/maintenance/partner/PartnerDriverMaintenanceController';
import { PartnerCarrierMaintenanceController } from '@shared/src/controllers/maintenance/partner/PartnerCarrierMaintenanceController';
import { SharedRouteReturnBaseCreatePage } from '../../returns/create/shared.route.return.base.create.page';
import { RouteTypesModelsFuncionament } from '../../returns/create/RouteTypesModelsFuncionament';
import { PartnersController } from '@shared/src/controllers/link/partners.controller';

@Component({
	selector: 'shared-route-outbound-create-page',
	templateUrl: '../../returns/create/shared.route.return.base.create.page.html',
	styleUrls: ['../../returns/create/shared.route.return.base.create.page.scss']
})
export class SharedRouteOutBoundCreatePage extends SharedRouteReturnBaseCreatePage {

	constructor(public routeController: RouteController,
		public shipmentController: ShipmentController,
		public fb: FormBuilder,
		@Inject('HomeController') protected homeController: HomeController,
		@Inject("SecurityController") protected securityController: SecurityController,
		@Inject("AlertService") protected alertService: AlertService,
		protected addressController: AddressController,
		protected partnersController: PartnersController,
		protected partnerDriverController: PartnerDriverMaintenanceController,
		protected partnerCarrierController: PartnerCarrierMaintenanceController,
		protected translateService: TranslateService) {

		super(RouteTypesModelsFuncionament.build().setTypeAsOutBound(), routeController, shipmentController, fb, homeController, securityController, alertService, addressController, partnersController, partnerDriverController, partnerCarrierController, translateService);
	}
}